import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ResponsiveService {

  public isMobileCartShowedSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public isMobileCartShowed$ = this.isMobileCartShowedSubject.asObservable();
}
